import { useState } from 'react';

import { OptionType } from '@/types';

const useSelectedDevice = () => {
  const [selectedDevice, setSelectedDevice] = useState<null | OptionType | undefined>();

  return { selectedDevice, setSelectedDevice };
};

export default useSelectedDevice;
